import { connect, generatedActions } from "helpers/redux";

export default function (Component) {
    const mapDispatchToProps = (dispatch) => ({
        clearParams: (key, params = {}) =>
            dispatch(
                generatedActions[key].merge({
                    filters: [],
                    start: 0,
                    customFilters: {},
                    preparedFilter: {},
                    ...params,
                }),
            ),
    });
    return connect(() => ({}), mapDispatchToProps)(Component);
}
